import { render, staticRenderFns } from "./NewCredit.vue?vue&type=template&id=966ce6c8&scoped=true&"
import script from "./NewCredit.vue?vue&type=script&lang=js&"
export * from "./NewCredit.vue?vue&type=script&lang=js&"
import style0 from "./NewCredit.vue?vue&type=style&index=0&id=966ce6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966ce6c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow})
